//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  name: 'ExistingDomainDialog',
  components: {
    TeDialog: TeDialog
  },
  props: {
    domain: {
      default: ''
    },
    // this parameter contains the credential returned from a login social attempt.
    // It's needed to avoid to reopen an authorization popup after the user is prompted with this dialog when the domain is already registered under another workspace.
    credential: {
      default: function _default() {
        return null;
      }
    },
    callback: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    onContinue: function onContinue() {
      var _this = this;

      this.openDialog('UserConfirmationDialog', {
        type: 'warning',
        icon: 'fal:triangle-exclamation',
        title: this.$t('components.existingDomainDialog.sure_create_workspace'),
        html: true,
        message: "\n            ".concat(this.$t('components.existingDomainDialog.keep_in_mind'), ":\n            <ul>\n              <li>").concat(this.$t('components.existingDomainDialog.wont_be_able_join_workspace'), "</li>\n              <li>").concat(this.$t('components.existingDomainDialog.join_workspace_invited'), "</li>\n              <li>").concat(this.$t('components.existingDomainDialog.you_can_be_in_single_workspace'), "</li>\n            </ul>\n            <br>\n        "),
        onConfirm: function onConfirm() {
          if (_this.credential) {
            _this.callback(_this.credential, true);
          } else {
            _this.callback(true);
          }

          _this.$refs.dialog.hide();
        }
      });
    }
  }
};